import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import DashboardLayout from '../components/layout/DashboardLayout' 
import BackButton from '../components/BackButton' 
import { doc, getDoc, updateDoc, deleteDoc } from 'firebase/firestore' // <-- Tambahkan deleteDoc
import { getStorage, ref, deleteObject, uploadBytes, getDownloadURL } from 'firebase/storage' // <-- Tambahkan uploadBytes & getDownloadURL
import { getApp } from 'firebase/app' // <-- TAMBAHKAN IMPORT INI
import { getFunctions, httpsCallable } from 'firebase/functions'
import { db } from '../firebaseConfig'

// 👈 TAMBAHAN: Fungsi utilitas kompresi gambar sebelum upload
const compressImage = (file, maxWidth, maxHeight, quality = 0.7) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round((width * maxHeight) / height);
            height = maxHeight;
          }
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob((blob) => {
          resolve(new File([blob], file.name, { type: 'image/jpeg', lastModified: Date.now() }));
        }, 'image/jpeg', quality);
      };
    };
    reader.onerror = error => reject(error);
  });
};


export default function DriverApprovalPage({ user, onLogout }) {
  const { id } = useParams() // ID driver dari URL
  const navigate = useNavigate()
  
  const [isProcessing, setIsProcessing] = useState(false)
  const [isLoadingData, setIsLoadingData] = useState(true) // State loading ambil data
  const [driverData, setDriverData] = useState(null) // State penyimpan data asli

  // --- TAMBAHAN: State untuk Fitur Edit & View Gambar ---
  const [isEditing, setIsEditing] = useState(false)
  const [editFormData, setEditFormData] = useState({})
  const [fullScreenImage, setFullScreenImage] = useState(null)

  // --- AMBIL DATA REAL DARI FIRESTORE ---
  useEffect(() => {
    const fetchDriverData = async () => {
      try {
        const docRef = doc(db, 'drivers', id)
        const docSnap = await getDoc(docRef)
        
        if (docSnap.exists()) {
          const data = { id: docSnap.id, ...docSnap.data() }
          setDriverData(data)
          setEditFormData(data) // Masukkan data ke form edit sementara
        } else {
          alert('Data driver tidak ditemukan!')
          navigate('/drivers')
        }
      } catch (error) {
        console.error("Error fetching driver:", error)
        alert('Gagal mengambil data driver.')
      } finally {
        setIsLoadingData(false)
      }
    }

    if (id) fetchDriverData()
  }, [id, navigate])

  // --- FUNGSI AKSI KE FIRESTORE ---
  const handleApprove = async () => {
    if (window.confirm(`Yakin ingin MENYETUJUI pendaftaran ${driverData.name}?`)) {
      setIsProcessing(true)
      try {
        const docRef = doc(db, 'drivers', id)
        // Ubah status menjadi Aktif
        await updateDoc(docRef, { 
          status: 'Aktif',
          approvedAt: new Date() // Menyimpan waktu persetujuan
        })
        alert(`Pendaftaran driver ${driverData.name} berhasil DISETUJUI!`)
        navigate('/drivers')
      } catch (error) {
        console.error("Error approving:", error)
        alert("Gagal menyetujui pendaftaran.")
      } finally {
        setIsProcessing(false)
      }
    }
  }

  const handleReject = async () => {
    const reason = prompt("Masukkan alasan penolakan/perbaikan (misal: KTP buram):")
    if (reason) {
      setIsProcessing(true)
      try {
        const docRef = doc(db, 'drivers', id)
        // Ubah status jadi Belum Lengkap/Ditolak agar user bisa memperbaiki di aplikasi
        await updateDoc(docRef, { 
          status: 'Belum Lengkap', 
          rejectReason: reason 
        })
        alert(`Pendaftaran dikembalikan ke driver. Alasan: ${reason}`)
        navigate('/drivers')
      } catch (error) {
        console.error("Error rejecting:", error)
        alert("Gagal menolak pendaftaran.")
      } finally {
        setIsProcessing(false)
      }
    }
  }
  // --- FUNGSI HAPUS AKUN & FOTO PERMANEN ---
  const handleDelete = async () => {
    const confirmDelete = window.confirm(
      `PERINGATAN BAHAYA!\n\nApakah Anda yakin ingin MENGHAPUS akun ${driverData.name} secara permanen?\n\nSemua data profil dan dokumen foto di database akan terhapus dan tidak dapat dikembalikan.`
    )
    
    if (confirmDelete) {
      setIsProcessing(true)
      try {
        const storage = getStorage()
        
        // 1. Hapus semua foto di Firebase Storage terlebih dahulu
        if (driverData.photos) {
          const photoUrls = Object.values(driverData.photos)
          for (const url of photoUrls) {
            // Pastikan URL asli dari Firebase, bukan link kosong atau dummy
            if (url && url.includes('firebasestorage.googleapis.com')) {
              try {
                const fileRef = ref(storage, url)
                await deleteObject(fileRef)
              } catch (imgError) {
                console.warn("Gambar gagal dihapus (mungkin sudah tidak ada):", imgError)
              }
            }
          }
        }

        // 2. Hapus data profil di Firestore
        await deleteDoc(doc(db, 'drivers', id))

        alert(`Akun driver ${driverData.name} beserta seluruh fotonya berhasil DIHAPUS permanen!`)
        navigate('/drivers')
      } catch (error) {
        console.error("Error deleting driver:", error)
        alert("Gagal menghapus akun driver.")
      } finally {
        setIsProcessing(false)
      }
    }
  }

  // --- FUNGSI SIMPAN EDIT DATA DRIVER ---
  const handleSaveEdit = async () => {
    setIsProcessing(true)
    try {
      // --- TAMBAHAN KODE: Panggil Cloud Function khusus jika Nomor HP berubah ---
      if (editFormData.phone !== driverData.phone) {
        // Firebase Auth mewajibkan format kode negara (contoh: +62812...)
        // Pastikan .trim() aman jika data kosong
        let formattedPhone = (editFormData.phone || '').trim()
        if (formattedPhone.startsWith('0')) {
          formattedPhone = '+62' + formattedPhone.substring(1)
        } else if (!formattedPhone.startsWith('+')) {
          formattedPhone = '+' + formattedPhone
        }

        // [PERBAIKAN] Tambahkan db.app dan arahkan region persis ke Jakarta
        // Memaksa React untuk mencari fungsi di server Jakarta
        const functions = getFunctions(getApp(), 'asia-southeast2')
        const updatePhoneFunc = httpsCallable(functions, 'updateMitraPhone')
        
        const result = await updatePhoneFunc({
          uid: id,
          newPhone: formattedPhone,
          collectionName: 'drivers' // Sesuaikan dengan nama tabel di database-mu
        })

        if (!result.data.success) {
          alert("Gagal mengganti nomor login di sistem otentikasi: " + result.data.error)
          setIsProcessing(false)
          return // Batalkan proses simpan karena eksekusi backend gagal
        }

        // Perbarui data form dengan format nomor yang sudah distandarkan agar rapi di Firestore
        editFormData.phone = formattedPhone
      }
      // -------------------------------------------------------------------------

      const docRef = doc(db, 'drivers', id)
      await updateDoc(docRef, {
        name: editFormData.name,
        nik: editFormData.nik,
        phone: editFormData.phone, // Nomor (lama maupun baru) tetap akan ter-update ke Firestore
        address: editFormData.address,
        vehicleType: editFormData.vehicleType || '',
        vehicleBrand: editFormData.vehicleBrand,
        vehicleYear: editFormData.vehicleYear,
        vehiclePlate: editFormData.vehiclePlate,
      })
      
      // Update tampilan langsung
      setDriverData(editFormData)
      setIsEditing(false)
      alert("Data driver berhasil diperbarui!")
    } catch (error) {
      console.error("Error updating driver:", error)
      // [PERBAIKAN] Tampilkan pesan error spesifik dari Firebase
      alert("Gagal memperbarui data driver: " + error.message)
    } finally {
      setIsProcessing(false)
    }
  }

  const handleEditChange = (e) => {
    setEditFormData({ ...editFormData, [e.target.name]: e.target.value })
  }

  // 👈 TAMBAHAN: Fungsi admin untuk mengganti dan mengompres foto
  const handleUpdatePhoto = async (photoKey, file) => {
    if (!file) return;
    setIsProcessing(true);
    try {
      // 1. Kompres gambar (Maksimal 1024px, kualitas 70%)
      const compressedFile = await compressImage(file, 1024, 1024, 0.7);
      const storage = getStorage();
      const fileExt = compressedFile.name.split('.').pop() || 'jpg';
      const fileName = `drivers/${id}/${photoKey}_admin_edit_${Date.now()}.${fileExt}`;
      const storageRef = ref(storage, fileName);

      // 2. Upload gambar baru
      await uploadBytes(storageRef, compressedFile);
      const newUrl = await getDownloadURL(storageRef);

      // 3. Hapus gambar lama jika ada dan berasal dari Firebase Storage
      const oldUrl = driverData.photos?.[photoKey];
      if (oldUrl && oldUrl.includes('firebasestorage.googleapis.com')) {
        try {
          const oldRef = ref(storage, oldUrl);
          await deleteObject(oldRef);
        } catch (imgError) {
          console.warn("Gambar lama tidak ditemukan atau gagal dihapus:", imgError);
        }
      }

      // 4. Update url di Firestore
      const docRef = doc(db, 'drivers', id);
      await updateDoc(docRef, {
        [`photos.${photoKey}`]: newUrl
      });

      // 5. Update state UI
      setDriverData(prev => ({
        ...prev,
        photos: { ...prev.photos, [photoKey]: newUrl }
      }));
      alert(`Foto dokumen berhasil diperbarui!`);
    } catch (error) {
      console.error("Error updating photo:", error);
      alert("Gagal memperbarui foto.");
    } finally {
      setIsProcessing(false);
    }
  };

  // Tampilkan loading screen jika data belum siap
  if (isLoadingData) {
    return (
      <DashboardLayout user={user} onLogout={onLogout}>
        <div className="flex justify-center items-center h-64 text-gray-400">
          <p>Memuat data driver...</p>
        </div>
      </DashboardLayout>
    )
  }

  // Jika data tidak ada (untuk keamanan tambahan)
  if (!driverData) return null;

  return (
    <DashboardLayout user={user} onLogout={onLogout}>
      <div className="text-gray-300 max-w-6xl mx-auto pb-10">
        <BackButton label="Kembali ke Daftar Driver" />

        <div className="flex justify-between items-end mb-6">
          <div>
            <h2 className="text-2xl font-bold text-white">Profil Mitra: {driverData.name}</h2>
            <div className="flex gap-4 mt-1 text-gray-400">
              <p>Selesai Training: {driverData.trainingCompletedAt || '-'}</p>
              {/* 👈 PERBAIKAN: Format Rating 2 desimal (contoh: 5.00) */}
              <p className="text-yellow-400 font-semibold">
                ⭐ Rating: {driverData.avgRating ? Number(driverData.avgRating).toFixed(2) : (driverData.rating ? Number(driverData.rating).toFixed(2) : 'Baru')}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            {!isEditing ? (
              <button 
                onClick={() => setIsEditing(true)}
                className="px-4 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm font-semibold transition"
              >
                ✏️ Edit Data
              </button>
            ) : (
              <div className="flex gap-2">
                <button 
                  onClick={() => setIsEditing(false)}
                  className="px-4 py-1.5 bg-gray-700 hover:bg-gray-600 text-white rounded text-sm font-semibold transition"
                >
                  Batal
                </button>
                <button 
                  onClick={handleSaveEdit}
                  disabled={isProcessing}
                  className="px-4 py-1.5 bg-green-600 hover:bg-green-700 text-white rounded text-sm font-semibold transition disabled:opacity-50"
                >
                  {isProcessing ? 'Menyimpan...' : '💾 Simpan Perubahan'}
                </button>
              </div>
            )}
            <div className="px-4 py-1.5 bg-orange-500/20 text-orange-400 border border-orange-500/30 rounded-full text-sm font-semibold">
              {driverData.status}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* KOLOM KIRI: Data Teks */}
          <div className="lg:col-span-1 space-y-6">
            
            {/* Card Data Diri */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-5 shadow-lg">
              <h3 className="text-lg font-semibold text-white mb-4 border-b border-gray-800 pb-2">Identitas Pribadi</h3>
              <div className="space-y-3 text-sm">
                <div>
                  <p className="text-gray-500 mb-1">Nama Lengkap</p>
                  {isEditing ? (
                    <input name="name" value={editFormData.name || ''} onChange={handleEditChange} className="w-full bg-gray-800 border border-gray-700 rounded p-2 text-white" />
                  ) : <p className="text-white font-medium">{driverData.name}</p>}
                </div>
                <div>
                  <p className="text-gray-500 mb-1">NIK (KTP)</p>
                  {isEditing ? (
                    <input name="nik" value={editFormData.nik || ''} onChange={handleEditChange} className="w-full bg-gray-800 border border-gray-700 rounded p-2 text-white" />
                  ) : <p className="text-white font-medium">{driverData.nik}</p>}
                </div>
                <div>
                  <p className="text-gray-500 mb-1">No. HP Darurat</p>
                  {isEditing ? (
                    <input name="phone" value={editFormData.phone || ''} onChange={handleEditChange} className="w-full bg-gray-800 border border-gray-700 rounded p-2 text-white" />
                  ) : <p className="text-white font-medium">{driverData.phone}</p>}
                </div>
                <div>
                  <p className="text-gray-500 mb-1">Alamat Domisili</p>
                  {isEditing ? (
                    <textarea name="address" value={editFormData.address || ''} onChange={handleEditChange} rows="3" className="w-full bg-gray-800 border border-gray-700 rounded p-2 text-white"></textarea>
                  ) : <p className="text-white font-medium leading-relaxed">{driverData.address}</p>}
                </div>
              </div>
            </div>

            {/* Card Data Kendaraan */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-5 shadow-lg">
              <h3 className="text-lg font-semibold text-white mb-4 border-b border-gray-800 pb-2">Data Kendaraan</h3>
              <div className="space-y-3 text-sm">
                <div>
                  <p className="text-gray-500 mb-1">Merek Kendaraan</p>
                  {isEditing ? (
                    <input name="vehicleBrand" value={editFormData.vehicleBrand || ''} onChange={handleEditChange} className="w-full bg-gray-800 border border-gray-700 rounded p-2 text-white" />
                  ) : <p className="text-white font-medium">{driverData.vehicleBrand || '-'}</p>}
                </div>
                <div>
                  <p className="text-gray-500 mb-1">Tipe Kendaraan</p>
                  {isEditing ? (
                    <input name="vehicleType" value={editFormData.vehicleType || ''} onChange={handleEditChange} className="w-full bg-gray-800 border border-gray-700 rounded p-2 text-white" />
                  ) : <p className="text-white font-medium">{driverData.vehicleType || '-'}</p>}
                </div>
                <div>
                  <p className="text-gray-500 mb-1">Tahun</p>
                  {isEditing ? (
                    <input type="number" name="vehicleYear" value={editFormData.vehicleYear || ''} onChange={handleEditChange} className="w-full bg-gray-800 border border-gray-700 rounded p-2 text-white" />
                  ) : <p className="text-white font-medium">{driverData.vehicleYear}</p>}
                </div>
                <div>
                  <p className="text-gray-500 mb-1">Plat Nomor</p>
                  {isEditing ? (
                    <input name="vehiclePlate" value={editFormData.vehiclePlate || ''} onChange={handleEditChange} className="w-full bg-gray-800 border border-gray-700 rounded p-2 text-white uppercase" />
                  ) : (
                    <p className="text-white font-bold bg-gray-800 inline-block px-3 py-1 rounded mt-1 border border-gray-700">
                      {driverData.vehiclePlate}
                    </p>
                  )}
                </div>
              </div>
            </div>
            {/* --- KARTU BARU: MANAJEMEN LAYANAN DARI ADMIN --- */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-5 shadow-lg mb-6">
              <h3 className="text-lg font-semibold text-white mb-4 border-b border-gray-800 pb-2">Otorisasi Layanan</h3>
              <p className="text-xs text-gray-400 mb-4">Pilih layanan yang bisa diambil driver ini. Anda dapat memasukkan masa kedaluwarsa waktu (opsional).</p>
              
              <div className="space-y-3">
                {['ZiMotor', 'ZiMobil', 'ZiMobil Extra', 'Sepeda Motor (ZiMove)', 'Sedan (ZiMove)', 'MPV (ZiMove)', 'Blind Van (ZiMove)', 'Pickup Bak (ZiMove)'].map(svc => {
                  const adminData = driverData.adminServices?.[svc] || {};
                  const isActive = adminData.active === true;
                  const expireAt = adminData.expireAt?.toDate ? adminData.expireAt.toDate() : null;
                  const isExpired = expireAt && new Date() > expireAt;
                  const isCurrentlyOn = isActive && !isExpired;

                  return (
                    <div key={svc} className="p-3 bg-gray-800 rounded border border-gray-700 flex flex-col gap-2">
                      <div className="flex justify-between items-center">
                        <span className="text-white font-semibold">{svc}</span>
                        <span className={`text-xs px-2 py-1 rounded ${isCurrentlyOn ? 'bg-green-900/50 text-green-400' : 'bg-red-900/50 text-red-400'}`}>
                          {isCurrentlyOn ? 'Aktif' : 'Terkunci'}
                        </span>
                      </div>
                      {isCurrentlyOn && expireAt && (
                        <p className="text-xs text-orange-400">Kedaluwarsa: {expireAt.toLocaleString('id-ID')}</p>
                      )}
                      
                      <div className="flex gap-2 mt-2">
                        {!isCurrentlyOn ? (
                          <button 
                            onClick={async () => {
                              const hours = prompt(`Aktifkan ${svc} untuk berapa jam?\n(Ketik angka, atau kosongkan untuk aktif permanen)`);
                              if (hours === null) return; 
                              
                              let expDate = null;
                              if (hours && !isNaN(hours) && Number(hours) > 0) {
                                expDate = new Date();
                                expDate.setHours(expDate.getHours() + Number(hours));
                              }
                              
                              await updateDoc(doc(db, 'drivers', id), {
                                [`adminServices.${svc}`]: { active: true, expireAt: expDate }
                              });
                              alert(`Layanan ${svc} berhasil diaktifkan!`);
                              window.location.reload(); // Refresh instan
                            }}
                            className="flex-1 bg-green-600 hover:bg-green-500 text-white text-xs py-2 rounded transition font-bold"
                          >
                            + Beri Akses Layanan
                          </button>
                        ) : (
                          <button 
                            onClick={async () => {
                              await updateDoc(doc(db, 'drivers', id), {
                                [`adminServices.${svc}.active`]: false
                              });
                              window.location.reload();
                            }}
                            className="w-full bg-red-600/80 hover:bg-red-500 text-white text-xs py-2 rounded transition"
                          >
                            Cabut Akses Layanan
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            
            {/* Card Aksi Eksekusi */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-5 shadow-lg">
              <h3 className="text-lg font-semibold text-white mb-4">Aksi Akun</h3>
              
              {/* --- LOGIKA BARU: Tampilkan tombol persetujuan hanya jika belum aktif --- */}
              {driverData.status !== 'Aktif' && driverData.status !== 'Suspended' ? (
                <>
                  <p className="text-xs text-gray-400 mb-4">Pastikan seluruh dokumen valid sebelum menyetujui akun ini beroperasi.</p>
                  <div className="space-y-3">
                    <button 
                      onClick={handleApprove}
                      disabled={isProcessing}
                      className="w-full bg-green-600 hover:bg-green-700 text-white py-2.5 rounded-lg font-semibold transition disabled:opacity-50"
                    >
                      {isProcessing ? 'Memproses...' : '✅ Setujui Pendaftaran'}
                    </button>
                    <button 
                      onClick={handleReject}
                      disabled={isProcessing}
                      className="w-full bg-red-900/40 hover:bg-red-600 border border-red-800 text-red-100 py-2.5 rounded-lg font-semibold transition disabled:opacity-50"
                    >
                      ❌ Tolak / Minta Perbaikan
                    </button>
                  </div>
                </>
              ) : (
                <p className="text-sm text-green-400 mb-4 font-semibold">✅ Akun ini sudah beroperasi.</p>
              )}

              <div className="space-y-3 mt-3">
                {/* --- TAMBAHAN KODE: Tombol Hapus --- */}
                <div className="pt-4 mt-2 border-t border-gray-800">
                  <button 
                    onClick={handleDelete}
                    disabled={isProcessing}
                    className="w-full bg-transparent hover:bg-red-900/80 border border-red-900 text-red-500 py-2 rounded-lg text-sm font-semibold transition disabled:opacity-50"
                  >
                    🗑️ Hapus Akun & Data Permanen
                  </button>
                </div>
              </div>
            </div>

          </div>

          {/* KOLOM KANAN: Galeri Foto Dokumen */}
          <div className="lg:col-span-2">
            <div className="bg-gray-900 border border-gray-800 rounded-xl p-5 shadow-lg">
              <h3 className="text-lg font-semibold text-white mb-4 border-b border-gray-800 pb-2">
                Dokumen Fisik {isEditing && <span className="text-sm text-blue-400 ml-2 font-normal">(Klik foto untuk mengubah)</span>}
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <DocViewer title="Foto Profil" url={driverData?.photos?.profile || 'https://via.placeholder.com/300x300.png?text=Belum+Ada+Foto'} onClick={setFullScreenImage} isEditing={isEditing} photoKey="profile" onUpload={handleUpdatePhoto} />
                <DocViewer title="Selfie dengan KTP" url={driverData?.photos?.selfieKtp || 'https://via.placeholder.com/300x400.png?text=Belum+Ada+Foto'} onClick={setFullScreenImage} isEditing={isEditing} photoKey="selfieKtp" onUpload={handleUpdatePhoto} />
                <DocViewer title="Foto KTP Asli" url={driverData?.photos?.ktp || 'https://via.placeholder.com/400x250.png?text=Belum+Ada+Foto'} onClick={setFullScreenImage} isEditing={isEditing} photoKey="ktp" onUpload={handleUpdatePhoto} />
                <DocViewer title="Foto SIM" url={driverData?.photos?.sim || 'https://via.placeholder.com/400x250.png?text=Belum+Ada+Foto'} onClick={setFullScreenImage} isEditing={isEditing} photoKey="sim" onUpload={handleUpdatePhoto} />
                <DocViewer title="Foto STNK" url={driverData?.photos?.stnk || 'https://via.placeholder.com/400x250.png?text=Belum+Ada+Foto'} onClick={setFullScreenImage} isEditing={isEditing} photoKey="stnk" onUpload={handleUpdatePhoto} />
                <DocViewer title="Fisik Kendaraan" url={driverData?.photos?.vehicle || 'https://via.placeholder.com/400x300.png?text=Belum+Ada+Foto'} onClick={setFullScreenImage} isEditing={isEditing} photoKey="vehicle" onUpload={handleUpdatePhoto} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- MODAL GAMBAR LAYAR PENUH --- */}
      {fullScreenImage && (
        <div 
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 cursor-zoom-out"
          onClick={() => setFullScreenImage(null)}
        >
          <button 
            className="absolute top-6 right-6 text-white bg-gray-800 hover:bg-red-600 rounded-full w-10 h-10 flex items-center justify-center text-xl transition"
            onClick={() => setFullScreenImage(null)}
          >
            ✕
          </button>
          <img 
            src={fullScreenImage} 
            alt="Dokumen Fisik" 
            className="max-w-full max-h-full object-contain rounded"
            onClick={(e) => e.stopPropagation()} // Mencegah klik pada gambar menutup modal
          />
        </div>
      )}

    </DashboardLayout>
  )
}

// Komponen kecil bantuan untuk menampilkan gambar dokumen (Diperbarui)
function DocViewer({ title, url, onClick, isEditing, photoKey, onUpload }) {
  const fileInputRef = React.useRef(null);

  const handleClick = () => {
    if (isEditing) {
      fileInputRef.current.click(); // Buka dialog pilih file jika sedang mode edit
    } else {
      onClick(url); // Perbesar gambar jika tidak dalam mode edit
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onUpload(photoKey, file);
    }
  };

  return (
    <div className="flex flex-col">
      <p className="text-sm text-gray-400 mb-2 font-medium">{title}</p>
      <div 
        className="bg-gray-800 rounded-lg overflow-hidden border border-gray-700 group relative cursor-pointer"
        onClick={handleClick}
      >
        <img 
          src={url} 
          alt={title} 
          className={`w-full h-48 object-cover transition duration-300 ${isEditing ? 'opacity-80 group-hover:opacity-60' : 'group-hover:opacity-75'}`}
        />
        <div className={`absolute inset-0 flex items-center justify-center transition duration-300 ${isEditing ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}>
          <span className={`${isEditing ? 'bg-blue-600' : 'bg-gray-900/80'} text-white px-4 py-2 rounded-lg text-sm shadow-lg backdrop-blur-sm flex items-center gap-2`}>
            {isEditing ? '📷 Ubah Foto' : '🔍 Lihat Penuh'}
          </span>
        </div>
      </div>
      {/* Input file tersembunyi yang hanya digunakan saat mode edit */}
      <input 
        type="file" 
        accept="image/*" 
        ref={fileInputRef} 
        onChange={handleFileChange} 
        className="hidden" 
      />
    </div>
  )
}